export default __webpack_public_path__ + "static/media/forget.fc3d7529.jpg";